import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  EUROCOUPONS_THIRDPARTY(state, euroCouponsThirdparty) {
    state.cached = euroCouponsThirdparty
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchEuroCouponsThirdparty(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/thirdparty/${query}`).then((response) => {
      const request = response.data
      context.commit('EUROCOUPONS_THIRDPARTY', request)
      return request
    })
  },

  fetchEuroCouponsThirdpartyOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/thirdparty/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchEuroCouponsCashRegisterThirdpartyOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/thirdparty/cash_register_options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchEuroCouponsThirdpartyDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateEuroCouponsThirdparty(context, formData) {
    let promise = null
    let url = formData.get('url')
    if ( url ){
      promise =  axios.put(url, formData, {
        headers: {'Content-Type': 'multipart/form-data'}})
    }else {
      promise =  axios.post(`${serverUrl}/euro_coupons/thirdparty/`, formData, {
        headers: {'Content-Type': 'multipart/form-data'}})
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deleteEuroCouponsThirdparty(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}